<template>
    <div>
      <me-action-sheet
        :value="sheetShow"
        :class="'action-title'"
        @cancel="$emit('cancel')"
        @click-overlay="$emit('cancel')"
        :closeable="false"
        title="创建问卷"
      >
        <ul class="create-type">
            <li @click="create">
                <me-icon name="add-o" />
                <div>从空白创建</div>
            </li>
            <li @click="createFormTemplate">
                <me-icon name="orders-o" />
                <div>从模板创建</div>
            </li>
        </ul>
        <me-button block class="close-btn" @click="$emit('cancel')">关闭</me-button>
      </me-action-sheet>
    </div>
  </template>
  <script>
  
  export default {
      props: {
          sheetShow: {
              type: Boolean,
              default: false,
          },
      },
      data() {
          return {
  
          }
      },
      methods: {
        create() {
            this.$router.push({
                name: 'create',
            })
        },
        createFormTemplate() {
          this.$store.commit('updateCreateTemplateTitle', '创建呱呱问卷')
          this.$router.push({
              name: 'template',
          })
        }
      },
  }
  </script>
  <style lang="scss" scoped>
  .me-action-sheet__header {
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    word-wrap: break-word;
    width: 80%;
    margin: 0 auto;
    color: #303741;
    font-size: 16px;
    height: 40px;
    line-height: 40px;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
  .action-sheet {
  
    border-top: 0.5px solid #F2F4F6;
    margin-bottom: 10px;
  
    > .me-col {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .action-item {
        margin: 10px;
        .icon {
          width: 24px;
          height: 24px;
        }
        .txt {
          margin-top: 10px;
          font-size: 12px;
          text-align: center;
        }
      }
    }
    .close-btn{
        border: none;
    }
  }
  .me-button--default{
    border: none;
    background: #F2F4F6;
  }
  .create-type{
    display: flex;
    justify-content: space-around;
    margin: 10px 0;
    li{
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #06B455;
      i{
        font-size: 36px;
      }
      div{
        margin: 10px 0;
        color: #9298A8;
      }
    }
  }
  .me-loading {
    position: absolute;
    z-index: 9000;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  </style>
  